import React from 'react';
import { createRoot } from 'react-dom/client';
import { ClerkProvider } from '@clerk/clerk-react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './index.css';
import App from './App';
import axios from 'axios';
import reportWebVitals from './reportWebVitals';

// CRA error overlay treats this benign Chrome ResizeObserver quirk as a fatal runtime error.
const isBenignResizeObserverError = (msg) =>
  typeof msg === 'string' &&
  (msg.includes('ResizeObserver loop completed with undelivered notifications') ||
    msg.includes('ResizeObserver loop limit exceeded'));

window.addEventListener('error', (event) => {
  if (isBenignResizeObserverError(event.message)) {
    event.stopImmediatePropagation();
  }
});

const clerkPubKey = 'pk_test_Z29sZGVuLWxvY3VzdC05Ny5jbGVyay5hY2NvdW50cy5kZXYk';

if (!clerkPubKey) {
  throw new Error('Missing Clerk Publishable Key. Please add VITE_CLERK_PUBLISHABLE_KEY to your .env file');
}
axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL;
const container = document.getElementById('root');
const root = createRoot(container);

root.render(
    <ClerkProvider 
      publishableKey={clerkPubKey} 
      afterSignOutUrl="/"
      signInUrl="/sign-in"
    >
      <App />
    </ClerkProvider>
);

reportWebVitals();
